import { FC } from "react";
import { PendingUnprocessedSpecialtyGroupExceptionsChanges } from "@app/projects/servicing-provider/PendingUnprocessedSpecialtyGroupExceptionsChanges";
import { FlyoutLink } from "@app/shared/Flyouts";

interface PendingUnprocessedSpecialtyGroupExceptionsChangesSidePanelLinkProps {
  onSubmit?: () => void;
  isZipProject?: boolean;
  projectId: number;
}

const PendingUnprocessedSpecialtyGroupExceptionsChangesSidePanelLink: FC<PendingUnprocessedSpecialtyGroupExceptionsChangesSidePanelLinkProps> = (props: PendingUnprocessedSpecialtyGroupExceptionsChangesSidePanelLinkProps) => {
  return (
    <FlyoutLink
      classNames="text-info ms-3"
      content={{
        body: (
          <PendingUnprocessedSpecialtyGroupExceptionsChanges
            isZipProject={props.isZipProject}
            projectId={props.projectId}
          />
        ),
        title: "Unprocessed Specialty Group Exceptions",
      }}
      testId="pending-unprocessed-specialty-group-exceptions-changes__flyout"
    >
      <i className="fa fa-rocket" /> View and Process
    </FlyoutLink>
  );
}

export default PendingUnprocessedSpecialtyGroupExceptionsChangesSidePanelLink;
